import { ApolloLink } from "./ApolloLink.js";

/**
 * @deprecated Use `ApolloLink.from` instead. `concat` will be removed in a
 * future major version.
 */
export const concat = ApolloLink.concat;
